module.exports = __webpack_public_path__ + "media/images/combo-ipad-basics-dashboard-33d8a2bb.png";